import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const sectionSlice = createSlice({
  name: 'section',
  initialState: {
    leftOpen: true,
    rightOpen: false,
    rightSectionOpen: false,
  },
  reducers: {
    toggleLeftSection(state) {
      state.leftOpen = !state.leftOpen;
    },
    toggleRightSection(state, action: PayloadAction<boolean | undefined>) {
      // If a boolean is provided, use it directly
      if (action.payload !== undefined) {
        state.rightOpen = action.payload;
        state.rightSectionOpen = action.payload;
      } else {
        // Otherwise toggle both states
        state.rightOpen = !state.rightOpen;
        state.rightSectionOpen = !state.rightSectionOpen;
      }
    },
    closeRightSection(state) {
      state.rightOpen = false;
    },
  },
});

export const { toggleLeftSection, toggleRightSection, closeRightSection } = sectionSlice.actions;
export default sectionSlice.reducer;
